/** 会员时长与时长折扣（与后端 MembershipBilling 一致） */
export const MEMBERSHIP_DURATION_OPTIONS = [
  { code: '1m', label: '1个月（月付）', months: 1, payPercent: 100, discountLabel: '原价' },
  { code: '2m', label: '2个月', months: 2, payPercent: 100, discountLabel: '原价' },
  { code: '3m', label: '3个月', months: 3, payPercent: 100, discountLabel: '原价' },
  { code: '4m', label: '4个月', months: 4, payPercent: 100, discountLabel: '原价' },
  { code: '5m', label: '5个月', months: 5, payPercent: 100, discountLabel: '原价' },
  { code: '6m', label: '6个月（半年付）', months: 6, payPercent: 98, discountLabel: '9.8折' },
  { code: '12m', label: '12个月（年付）', months: 12, payPercent: 90, discountLabel: '9折' },
  { code: '24m', label: '2年付', months: 24, payPercent: 85, discountLabel: '8.5折' },
  { code: '36m', label: '3年付', months: 36, payPercent: 80, discountLabel: '8折' },
];

export function formatDurationShortLabel(months) {
  const n = Number(months);
  if (n === 6) return '半年';
  if (n === 12) return '1年';
  if (n === 24) return '2年';
  if (n === 36) return '3年';
  return `${n}个月`;
}

/** 金额四舍五入到分（避免浮点误差） */
export function roundYuan(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

/** 展示用金额：最多保留两位小数，去掉多余尾零 */
export function formatYuanAmount(value) {
  const rounded = roundYuan(value);
  return parseFloat(rounded.toFixed(2)).toString();
}

export function calcMembershipOriginalTotal(monthlyPrice, months) {
  const price = Number(monthlyPrice) || 0;
  const m = Number(months) || 1;
  return roundYuan(price * m);
}

export function calcMembershipTotalPrice(monthlyPrice, months) {
  const price = Number(monthlyPrice) || 0;
  const option = MEMBERSHIP_DURATION_OPTIONS.find((o) => o.months === months)
    || MEMBERSHIP_DURATION_OPTIONS[0];
  const total = price * option.months * (option.payPercent / 100);
  return Math.round(total * 100) / 100;
}

export function formatMonthlyPrice(priceYuan) {
  const p = roundYuan(priceYuan);
  if (!p) return '免费';
  return `¥${formatYuanAmount(p)}/月`;
}

export function formatDurationPrice(monthlyPrice, months) {
  const total = calcMembershipTotalPrice(monthlyPrice, months);
  if (!total) return '免费';
  const option = MEMBERSHIP_DURATION_OPTIONS.find((o) => o.months === months);
  const suffix = option && option.payPercent < 100 ? `（${option.discountLabel}）` : '';
  return `¥${formatYuanAmount(total)}${suffix}`;
}

/** IPE豆套餐：月付价 × 时长折扣 */
export function calcCreditRechargePrice(monthlyPriceYuan, months) {
  return calcMembershipTotalPrice(monthlyPriceYuan, months);
}

/** 默认 7 档：单价 0.15 → 0.055/豆（运营后台可编辑，此处为离线兜底） */
export const CREDIT_PACK_MONTHLY = [
  { credits: 500, monthlyPriceYuan: 75 },
  { credits: 2000, monthlyPriceYuan: 260 },
  { credits: 5000, monthlyPriceYuan: 500 },
  { credits: 10000, monthlyPriceYuan: 900 },
  { credits: 20000, monthlyPriceYuan: 1500 },
  { credits: 50000, monthlyPriceYuan: 3000 },
  { credits: 100000, monthlyPriceYuan: 5500 },
];

/** 月付参考价折算为单豆单价（元/豆） */
export function formatPricePerBean(credits, monthlyPriceYuan) {
  const amount = Number(credits) || 0;
  const price = Number(monthlyPriceYuan) || 0;
  if (amount <= 0 || price <= 0) return '-';
  const unit = Math.round((price / amount) * 10000) / 10000;
  const text = unit >= 0.1 ? unit.toFixed(3) : unit.toFixed(4);
  return `¥${text.replace(/\.?0+$/, '')}/豆`;
}

export const DURATION_SHORT_LABELS = {
  1: '月卡',
  2: '2个月',
  3: '3个月',
  4: '4个月',
  5: '5个月',
  6: '半年卡',
  12: '年卡',
  24: '2年卡',
  36: '3年卡',
};

export const SHOP_EXPAND_PRESETS = [1, 2, 3, 5, 10];

/** 单店月付参考价（元/店/月） */
export const SHOP_MONTHLY_YUAN_PER_SHOP = 9.9;

/** 默认店铺扩容阶梯（运营后台可编辑，此处为离线兜底） */
export const SHOP_PACK_MONTHLY = [
  { shopCount: 1, monthlyPriceYuan: 9.9 },
  { shopCount: 2, monthlyPriceYuan: 19.9 },
  { shopCount: 3, monthlyPriceYuan: 29.7 },
  { shopCount: 5, monthlyPriceYuan: 49.5 },
  { shopCount: 10, monthlyPriceYuan: 99 },
];

/** 店铺扩容时长折扣：半年9折；1年8折；2年7折；3年6折；其余原价 */
export function shopExpandPayPercent(months) {
  const m = Number(months) || 1;
  if (m === 6) return 90;
  if (m === 12) return 80;
  if (m === 24) return 70;
  if (m === 36) return 60;
  return 100;
}

export function shopExpandDiscountLabel(months) {
  const payPercent = shopExpandPayPercent(months);
  if (payPercent >= 100) return null;
  if (payPercent % 10 === 0) return `${payPercent / 10}折`;
  return `${payPercent / 10}折`;
}

export function calcShopExpandTotalPrice(monthlyPrice, months) {
  const price = Number(monthlyPrice) || 0;
  const m = Number(months) || 1;
  const option = MEMBERSHIP_DURATION_OPTIONS.find((o) => o.months === m)
    || MEMBERSHIP_DURATION_OPTIONS[0];
  const total = price * option.months * (shopExpandPayPercent(option.months) / 100);
  return Math.round(total * 100) / 100;
}

export function formatShopDurationPrice(monthlyPrice, months) {
  const total = calcShopExpandTotalPrice(monthlyPrice, months);
  if (!total) return '免费';
  const label = shopExpandDiscountLabel(months);
  const suffix = label ? `（${label}）` : '';
  return `¥${formatYuanAmount(total)}${suffix}`;
}

export function monthlyPriceForCredits(credits, packs = CREDIT_PACK_MONTHLY) {
  const amount = Number(credits) || 0;
  if (amount <= 0) return 0;
  const list = packs?.length ? packs : CREDIT_PACK_MONTHLY;
  const exact = list.find((p) => Number(p.credits) === amount);
  if (exact) return Number(exact.monthlyPriceYuan);
  const base = list[1] || list[0];
  if (!base) return 0;
  return Math.round((Number(base.monthlyPriceYuan) * amount / Number(base.credits)) * 100) / 100;
}

export function calcCreditAmountPrice(credits, months, packs) {
  return calcCreditRechargePrice(monthlyPriceForCredits(credits, packs), months);
}

/** 店铺扩容：月付价 × 店铺专属时长规则 */
export function calcShopExpandPrice(monthlyYuanPerShop, shopCount, months) {
  const count = Number(shopCount) || 0;
  return calcShopExpandTotalPrice((Number(monthlyYuanPerShop) || 0) * count, months);
}
